/**
 * CNESConsultaPage - CNES Hospital Search Page
 * Refactored to use extracted hook and components
 */
import React from 'react';
import { useCNESConsulta } from '../hooks/useCNESConsulta';
import {
  CNESHeader,
  CNESFilters,
  CNESResultsTable,
  CNESDetailModal,
  CNESInfoCard,
  CNESLoadingState,
} from '../components/cnes-consulta';

export const CNESConsultaPage = () => {
  const {
    // Filter state
    filtros,
    setFiltros,
    buscaExata,
    setBuscaExata,

    // Results
    sortedResultados,
    buscaRealizada,
    loading,

    // Sorting
    sortConfigs,
    handleSort,

    // Detail modal
    selectedHospitalDetail,
    showDetailModal,
    handleViewDetails,
    closeDetailModal,

    // Actions
    handleBuscar,
    handleAtualizar,
    handleLimpar,
    handleExportar,
    handleExportarTudo,
  } = useCNESConsulta();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-green-50 p-6">
      <div className="max-w-7xl mx-auto">
        <CNESHeader />

        <CNESFilters
          filtros={filtros}
          setFiltros={setFiltros}
          buscaExata={buscaExata}
          setBuscaExata={setBuscaExata}
          sortConfigs={sortConfigs}
          buscaRealizada={buscaRealizada}
          resultadosCount={sortedResultados.length}
          onBuscar={handleBuscar}
          onAtualizar={handleAtualizar}
          onLimpar={handleLimpar}
          onExportar={handleExportar}
          onExportarTudo={handleExportarTudo}
        />

        {/* Loading Indicator */}
        {loading && <CNESLoadingState />}

        {/* Results */}
        {!loading && buscaRealizada && (
          <div className="bg-white rounded-xl shadow-lg p-6">
            <h2 className="text-lg font-semibold text-gray-900 mb-4">
              Resultados da Busca ({sortedResultados.length})
              {sortConfigs.length > 0 && (
                <span className="ml-2 text-sm text-gray-500">
                  (Ordenado por: {sortConfigs.map(c => c.key).join(', ')})
                </span>
              )}
            </h2>

            <CNESResultsTable
              resultados={sortedResultados}
              sortConfigs={sortConfigs}
              onSort={handleSort}
              onViewDetails={handleViewDetails}
            />
          </div>
        )}

        {/* Info Card */}
        {!buscaRealizada && <CNESInfoCard />}
      </div>

      {/* Detail Modal */}
      {showDetailModal && selectedHospitalDetail && (
        <CNESDetailModal
          hospital={selectedHospitalDetail}
          onClose={closeDetailModal}
        />
      )}
    </div>
  );
};
